import React from "react";
import "../css/privacy.scss";

function Accessibility() {
  return (
    <main className="accessibility policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Accessibility Statement</h1>
        <div className="policy-content">
          <p>Uightparcel aims to make uightparcel.shop usable by as many people as possible, including people who use keyboards, screen readers, zoom or other assistive technology.</p>
          <h2>What we support</h2>
          <ul>
            <li>Semantic headings, landmarks and meaningful link text.</li>
            <li>Keyboard access to navigation, product options and FAQ disclosures.</li>
            <li>Visible focus indicators and responsive layouts.</li>
            <li>Text alternatives for meaningful visuals.</li>
            <li>Reduced-motion preferences where animation is used.</li>
          </ul>
          <h2>Known limitations</h2>
          <p>The site is still under review. Some colour combinations, legacy component styles or third-party browser behaviour may not yet provide an ideal experience. Product images are AI-generated visual representations and each includes descriptive alternative text.</p>
          <h2>Feedback</h2>
          <p>If you have difficulty using the site, email <a href="mailto:track@uightparcel.shop?subject=Accessibility%20feedback">track@uightparcel.shop</a>. Include the page URL, what you were trying to do and, if helpful, your browser or assistive technology. We will use the information to investigate and improve the experience.</p>
          <h2>Ongoing work</h2>
          <p>Accessibility is reviewed when features and content are added. A formal conformance claim will only be made after an appropriate audit.</p>
        </div>
      </div>
    </main>
  );
}

export default Accessibility;
